module.exports = __webpack_public_path__ + "img/Star.07244902.jpg";